export const getHostname = () => window.location.hostname

export const navigateTo = url => {
  window.location.href = url
}
